/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2021-12-14 07:49:44
 *
 *******************************************************/
// @flow
export const freeThemes = [
  'default',
  'debut',
  'pop',
  'venture',
  'jumpstart',
  'dawn',
  'sense',
  'craft',
  'crave',
  'taste',
  'studio',
  'colorblock',
  'ride',
  'refresh'
];

export const themeSupportV2 = [
  'blockshop',
  'craft',
  'crave',
  'colorblock',
  'dawn',
  'debut',
  'ella',
  'empire',
  'flex',
  'flow',
  'icon',
  'impulse',
  'motion',
  'prestige',
  'sense',
  'streamline',
  'superstore',
  'symmetry',
  'studio',
  'refresh',
  'ride',
  'taste',
  'testament',
  'turbo',
  'venture',
  'venue',
  'warehouse'
];

export const FEEDBACK_ALL = [
  { id: 1, label: `option1_All_RadioButton_Label`, value: 'I’m having technical issues' },
  {
    id: 2,
    label: `option2_All_RadioButton_Label`,
    value: 'The app lacks features or functionality I need'
  },
  { id: 3, label: `option3_All_RadioButton_Label`, value: 'The price is too high' },
  { id: 4, label: `option4_All_RadioButton_Label`, value: 'The app is difficult to use' },
  { id: 5, label: `option5_All_RadioButton_Label`, value: 'I’m switching to a different solution' },
  { id: 6, label: `option6_All_RadioButton_Label`, value: 'Other' }
];

export const FEEDBACK_SEARCH = [
  {
    id: 1,
    label: `option1_Search_RadioButton_Label`,
    value: 'Search feature is not performing well'
  },
  {
    id: 2,
    label: `option2_Search_RadioButton_Label`,
    value: 'I only need the filter feature'
  },
  {
    id: 3,
    label: `option3_Search_RadioButton_Label`,
    value: 'The search feature does not meet my needs'
  },
  { id: 4, label: `option4_Search_RadioButton_Label`, value: 'Other' }
];

export const TAR_FEATURE = {
  FILTER_SEARCH: 'filterSearch',
  FILTER_COLLECTION: 'filterCollection',
  INSTANT_SEARCH: 'instantSearch',
  RECOMMENDATION: 'recommendation'
};

export const getFeedbackOptions = (i18n: any, feature: string) => {
  if (!feature) {
    return FEEDBACK_MULTIPLE.map(item => ({
      ...item,
      label: i18n.translate(`AdminHTML.ThemeSetup.FeedbackModal.${item.label}`)
    }));
  }

  const result = FEEDBACK_TEMPLATE.map(item => {
    let label = '';
    if (item.id === 1 || item.id === 2) {
      label = i18n.translate(`AdminHTML.ThemeSetup.FeedbackModal.${item.label}`, {
        t: i18n.translate(`AdminHTML.ThemeSetup.FeedbackModal.feature_${feature}`)
      });
    } else {
      label = i18n.translate(`AdminHTML.ThemeSetup.FeedbackModal.${item.label}`);
    }

    return {
      ...item,
      label: label,
      value: item.value.replace(
        '{feature}',
        i18n.translate(`AdminHTML.ThemeSetup.FeedbackModal.feature_${feature}`)
      )
    };
  });
  return result;
};

export const FEEDBACK_TEMPLATE = [
  { id: 1, label: `option1_Template_RadioButton_Label`, value: '{feature} is not performing well' },
  {
    id: 2,
    label: `option2_Template_RadioButton_Label`,
    value: '{feature} does not meet my needs'
  },
  {
    id: 3,
    label: `option3_Template_RadioButton_Label`,
    value: 'It is difficult to understand how it works'
  },
  {
    id: 4,
    label: `option4_Template_RadioButton_Label`,
    value: "I'm switching to a different solution"
  },
  { id: 5, label: `option5_Template_RadioButton_Label`, value: 'App is not worth the cost' },
  { id: 6, label: `option6_Template_RadioButton_Label`, value: 'Other' }
];

export const FEEDBACK_MULTIPLE = [
  {
    id: 1,
    label: `option1_Multiple_RadioButton_Label`,
    value: 'These functions are not performing well'
  },
  {
    id: 2,
    label: `option2_Multiple_RadioButton_Label`,
    value: 'These functions do not meet my needs'
  },
  {
    id: 3,
    label: `option3_Multiple_RadioButton_Label`,
    value: 'It is difficult to understand how it works'
  },
  {
    id: 4,
    label: `option4_Multiple_RadioButton_Label`,
    value: "I'm switching to a different solution"
  },
  { id: 5, label: `option5_Multiple_RadioButton_Label`, value: 'App is not worth the cost' },
  { id: 6, label: `option6_Multiple_RadioButton_Label`, value: 'Other' }
];
